/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CompaniesDocumentsCreateBodyOne,
  CompaniesDocumentsCreateBodyTwo,
  CompaniesDocumentsListParams,
  CompanyDocument,
  PaginatedCompanyDocumentList
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Get all documents for the owner's company. Paginated.
 * @summary List company documents
 */
export const companiesDocumentsList = (
    params?: CompaniesDocumentsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedCompanyDocumentList>(
      {url: `/api/v1/companies/documents/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCompaniesDocumentsListQueryKey = (params?: CompaniesDocumentsListParams,) => {
    return [`/api/v1/companies/documents/`, ...(params ? [params]: [])] as const;
    }

    
export const getCompaniesDocumentsListQueryOptions = <TData = Awaited<ReturnType<typeof companiesDocumentsList>>, TError = unknown>(params?: CompaniesDocumentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesDocumentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesDocumentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesDocumentsList>>> = ({ signal }) => companiesDocumentsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesDocumentsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesDocumentsListQueryResult = NonNullable<Awaited<ReturnType<typeof companiesDocumentsList>>>
export type CompaniesDocumentsListQueryError = unknown

/**
 * @summary List company documents
 */
export const useCompaniesDocumentsList = <TData = Awaited<ReturnType<typeof companiesDocumentsList>>, TError = unknown>(
 params?: CompaniesDocumentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesDocumentsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesDocumentsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 
        Create a document by either:
        1. **Upload file** (preferred): multipart/form-data with `file` field. The file is
           stored in PRIVATE storage; `fileUrl` in responses is a short-lived signed link.
        2. **Register URL**: application/json with `fileUrl` pointing at a file the caller
           uploaded via `/api/v1/common/upload/`. The file is moved into private storage and
           its public copy is deleted. Any other URL is refused with 400.
        Accepted types: PDF, DOC, DOCX, JPG/JPEG, PNG; maximum 10 MB (400 `{"error": ...}` otherwise).
        Status starts as Pending. Admin can approve or reject in admin panel.
        
 * @summary Create company document
 */
export const companiesDocumentsCreate = (
    companiesDocumentsCreateBody: CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo,
 ) => {
      
      
      return customInstance<CompanyDocument>(
      {url: `/api/v1/companies/documents/`, method: 'POST',
      data: companiesDocumentsCreateBody
    },
      );
    }
  


export const getCompaniesDocumentsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesDocumentsCreate>>, TError,{data: CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesDocumentsCreate>>, TError,{data: CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesDocumentsCreate>>, {data: CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo}> = (props) => {
          const {data} = props ?? {};

          return  companiesDocumentsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesDocumentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesDocumentsCreate>>>
    export type CompaniesDocumentsCreateMutationBody = CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo
    export type CompaniesDocumentsCreateMutationError = void

    /**
 * @summary Create company document
 */
export const useCompaniesDocumentsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesDocumentsCreate>>, TError,{data: CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesDocumentsCreate>>,
        TError,
        {data: CompaniesDocumentsCreateBodyOne | CompaniesDocumentsCreateBodyTwo},
        TContext
      > => {

      const mutationOptions = getCompaniesDocumentsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * ViewSet for Company Documents - owner, approved companies only. Admin approves.
 * @summary Get company document
 */
export const companiesDocumentsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyDocument>(
      {url: `/api/v1/companies/documents/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getCompaniesDocumentsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/companies/documents/${id}/`] as const;
    }

    
export const getCompaniesDocumentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesDocumentsRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesDocumentsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesDocumentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesDocumentsRetrieve>>> = ({ signal }) => companiesDocumentsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesDocumentsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesDocumentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesDocumentsRetrieve>>>
export type CompaniesDocumentsRetrieveQueryError = unknown

/**
 * @summary Get company document
 */
export const useCompaniesDocumentsRetrieve = <TData = Awaited<ReturnType<typeof companiesDocumentsRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesDocumentsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesDocumentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * ViewSet for Company Documents - owner, approved companies only. Admin approves.
 * @summary Delete company document
 */
export const companiesDocumentsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/companies/documents/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getCompaniesDocumentsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesDocumentsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesDocumentsDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesDocumentsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  companiesDocumentsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesDocumentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesDocumentsDestroy>>>
    
    export type CompaniesDocumentsDestroyMutationError = unknown

    /**
 * @summary Delete company document
 */
export const useCompaniesDocumentsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesDocumentsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesDocumentsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getCompaniesDocumentsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    